// extracted by mini-css-extract-plugin
export default {"code-block":"CreateService_code-block__lltf8","template-block":"CreateService_template-block__1+Udx","ai-assist-modal":"CreateService_ai-assist-modal__vYWpe"};